import i18next from 'i18next'
import _ from 'lodash'
import { MoneyDto } from '../services/APIs/InternalAPI/internal-api.contracts'

export function MoneyIsValid(money: MoneyDto) {
  if (!money) return false

  return money.value > 0
}

export function MoneyString(
  money: MoneyDto,
  maximumFractionDigits?: number,
  replaceZeroWithString?: string,
  useCurrencyCodeAtEnd?: boolean,
) {
  if (!money) {
    return replaceZeroWithString || null
  }

  if (money.value == null) {
    return '-'
  }

  if (
    (!money || money.value === 0 || isNaN(money.value)) &&
    replaceZeroWithString !== undefined
  ) {
    return replaceZeroWithString
  }

  if (useCurrencyCodeAtEnd) {
    return formatWithCurrencyCodeAtEnd(money, maximumFractionDigits)
  }

  return formatLocalizedCurrency(
    i18next.language,
    money.currency,
    money.value,
    maximumFractionDigits,
  )
}

export function formatWithCurrencyCodeAtEnd(
  money: MoneyDto,
  maximumFractionDigits?: number,
) {
  if (!money) return null

  const formatedValue = new Intl.NumberFormat(i18next.language, {
    style: 'decimal',
    maximumFractionDigits: maximumFractionDigits ?? 2,
  }).format(money.value)

  return `${formatedValue} ${money.currency}`
}

export function formatLocalizedCurrency(
  language: string,
  currency: string,
  value: number,
  maximumFractionDigits?: number,
) {
  let languageAndCulture = language

  if (language.toLowerCase().startsWith('en')) {
    // HACK: If the language is English, we need to determine the culture based on the currency
    // this should came from the backend, in the party model;
    switch (currency) {
      case 'ZAR':
        // South African Rand
        languageAndCulture = 'en-ZA'
        break
      case 'USD':
        // US Dollar
        languageAndCulture = 'en-US'
        break
      case 'GBP':
        // British Pound
        languageAndCulture = 'en-GB'
        break
      case 'AUD':
        // Australian Dollar
        languageAndCulture = 'en-AU'
        break
      case 'CAD':
        // Canadian Dollar
        languageAndCulture = 'en-CA'
        break
      default:
        // Default to generic English
        languageAndCulture = 'en'
    }
  }

  return new Intl.NumberFormat(languageAndCulture, {
    style: 'currency',
    currency: currency || 'EUR',
    maximumFractionDigits: maximumFractionDigits ?? 2,
  }).format(value)
}

export function SumMoney(prices: MoneyDto[]): MoneyDto {
  const sumValue = _.sumBy(prices, (x) => x?.value || 0)

  return {
    ...prices[0],
    value: sumValue,
  }
}

export function MultiplyMoney(money: MoneyDto, multiplicant: number) {
  return money && { ...money, value: money.value * multiplicant || 0 }
}
